import component from './withScrimmedPortal';

export default component;
